import { LOADING, BaseActionTypes, BaseState, ERROR, Error, Loading, ERROR_CLEAR, SUCCESS, Success, SUCCESS_CLEAR, SUCCESS_REMOVE, LOADING_REMOVE, ERROR_REMOVE, PARTIAL, Partial, PARTIAL_REMOVE, PARTIAL_CLEAR, TOAST, TOAST_REMOVE, Toast } from "domain/types/base/base"

const INITIAL_STATE: BaseState = {
    Loading: [],
    Error: [],
    Success: [],
    Partial: [],
    Toast: []
}

export function BaseReducer(state = INITIAL_STATE, action: BaseActionTypes): BaseState {
    switch (action.type) {

        case LOADING:
            return { ...state, Loading: [...state.Loading, action.payload] }

        case ERROR:
            return { ...state, Error: [...state.Error, action.payload] }

        case ERROR_CLEAR:
            return { ...state, Error: [] }

        case SUCCESS_REMOVE:
            return {
                ...state,
                Success: state.Success.filter((s, index) => index !== action.payload) // action.payload contém o índice
            };
        case SUCCESS:
            return { ...state, Success: [...state.Success, action.payload] }

        case SUCCESS_CLEAR:
            return { ...state, Success: [] }
            
            
        case LOADING_REMOVE:
            return {
                ...state,
                Loading: state.Loading.filter((s) => s.Name !== action.payload) // action.payload contém o índice
            };

        case ERROR_REMOVE:
            return {
                ...state,
                Loading: state.Error.filter((s) => s.Name !== action.payload) // action.payload contém o índice
            };

        case PARTIAL:
            return { ...state, Partial: [...state.Partial, action.payload] }

        case PARTIAL_REMOVE:
            return {
                ...state,
                Partial: state.Partial.filter((s, index) => index !== action.payload)
            };

        case PARTIAL_CLEAR:
            return { ...state, Partial: [] }

        case TOAST:
            return { ...state, Toast: [...state.Toast, action.payload] }

        case TOAST_REMOVE:
            return {
                ...state,
                Toast: state.Toast.filter((s) => s.Name !== action.payload) // action.payload contém o índice
            };

        default:
            break;
    }

    const loadingTracker = LoadingTracker(state, action)
    const errorTracker = ErrorTracker(state, action)
    const sucessTracker = SuccessTracker(state, action)
    const partialTracker = PartialTracker(state, action)
    const toastTracker = ToastTracker(state, action)

    return { ...state, Loading: loadingTracker, Error: errorTracker, Success: sucessTracker, Partial: partialTracker, Toast: toastTracker }
}

function LoadingTracker(state: BaseState, action: BaseActionTypes): Loading[] {
    if (action.type.includes("LOADING")) {
        const result = action.type.replace(/_LOADING$/, '');
        if (result) {
            const payload = (action.payload as Loading)
            const _loading: Loading = {
                Name: result,
                Type: payload.Type,
                Message: payload.Message,
                CallBack: payload.CallBack
            }
            return [...state.Loading, _loading]
        }
    } else {
        let copyLoading = [...state.Loading]
        const loadingElement = state.Loading.find((e) => e.Name == action.type)
        if (loadingElement != undefined && loadingElement != null) {
            copyLoading = copyLoading.filter((e) => e.Name !== loadingElement?.Name);
        }

        return copyLoading
    }
    return state.Loading
}



function ErrorTracker(state: BaseState, action: BaseActionTypes): Error[] {
    if (action.type.includes("ERROR")) {
        const result = action.type.replace(/_ERROR$/, '');
        if (result) {
            const payload = (action.payload as Error)
            const _error: Error = {
                Name: result,
                Type: payload.Type,
                Message: payload.Message,
                CallBack: payload.CallBack

            }
            return [...state.Error, _error]
        }
    } else {
        let copyError = [...state.Error]
        const errorElement = state.Loading.find((e) => e.Name == action.type)
        if (errorElement != undefined && errorElement != null) {
            copyError = copyError.filter((e) => e.Name !== errorElement?.Name);
        }

        return copyError
    }
    return state.Error
}

function SuccessTracker(state: BaseState, action: BaseActionTypes): Success[] {
    if (action.type.includes("SUCCESS")) {
        const result = action.type.replace(/_SUCCESS$/, '');
        if (result) {
            const payload = (action.payload as Success)
            const _success: Success = {
                Name: result,
                Type: payload.Type,
                Message: payload.Message,
                CallBack: payload.CallBack

            }
            return [...state.Success, _success]
        }
    } else {
        let copySuccess = [...state.Success]
        const successElement = state.Success.find((e) => e.Name == action.type)
        if (successElement != undefined && successElement != null) {
            copySuccess = copySuccess.filter((e) => e.Name !== successElement?.Name);
        }

        return copySuccess
    }
    return state.Success
}


function PartialTracker(state: BaseState, action: BaseActionTypes): Partial[] {
    if (action.type.includes("PARTIAL")) {
        const result = action.type.replace(/_PARTIAL$/, '');
        if (result) {
            const payload = (action.payload as Partial)
            const _partial: Partial = {
                Name: result,
                Type: payload.Type,
                Message: payload.Message,
                CallBack: payload.CallBack
            }
            return [...state.Partial, _partial]
        }
    } else {
        let copyPartial = [...state.Partial]
        const partialElement = state.Partial.find((e) => e.Name == action.type)
        if (partialElement != undefined && partialElement != null) {
            copyPartial = copyPartial.filter((e) => e.Name !== partialElement?.Name);
        }

        return copyPartial
    }
    return state.Partial
}

function ToastTracker(state: BaseState, action: BaseActionTypes): Toast[] {
    if (action.type.includes("TOAST")) {
        const result = action.type.replace(/_TOAST$/, '');
        if (result) {
            const payload = (action.payload as Toast)
            const _toast: Toast = {
                Name: result,
                Type: payload.Type,
                Message: payload.Message,
                CallBack: payload.CallBack

            }
            return [...state.Toast, _toast]
        }
    } else {
        let copyToast = [...state.Toast]
        const toastElement = state.Toast.find((e) => e.Name == action.type)
        if (toastElement != undefined && toastElement != null) {
            copyToast = copyToast.filter((e) => e.Name !== toastElement?.Name);
        }

        return copyToast
    }
    return state.Toast
}